import { ElementType, PropsWithChildren } from 'react';

interface OptionalBlockWrapperProps {
  className?: string;
  as?: string;
  condition?: unknown;
  dataTestId?: string;
}
export function OptionalBlockWrapper({
  children,
  className,
  as,
  condition,
  dataTestId = 'optional-block-wrapper',
}: PropsWithChildren<OptionalBlockWrapperProps>) {
  if (!condition) {
    return null;
  }
  if (!as) {
    return children;
  }

  if (className && !as) {
    throw new Error(
      'OptionalBlockWrapper returns fragment if you want to pass prop className you should pass specify wrapper tag by passing "as" prop'
    );
  }
  const Component = as as ElementType;

  return (
    <Component className={className} data-testid={dataTestId}>
      {children}
    </Component>
  );
}

export default OptionalBlockWrapper;
